<template>
  <b-modal
    id="RecruiterFeedback"
    ok-only
    ok-title="Submit feedback"
    ok-variant="primary"
    no-stacking
    centered
    @ok.prevent="submit"
  >
    <b-form v-if="match.id">
      <b-row>
        <b-col>
          <label class="h7 mb-3">
            Feedback for the {{ match.project.business.name }}
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label class="mb-3 h9 pl-3">
            How likely is it that you recommend client to a friend or colleague?
          </label>
          <span class="text-primary">*</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-radio-group
              v-model="score"
              :options="emojis"
              required
              buttons
              button-variant="emoji"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row class="mb-4">
      <b-col class="d-inline-flex">
        <b-col
          class="text-left h9"
          style="color: #F7625B;"
        >
          Not at all likely
        </b-col>
        <b-col
          class="text-right h9"
          style="color: #00A725;"
        >
          Extremely likely
        </b-col>
      </b-col>
    </b-row> -->
      <b-row>
        <b-col>
          <label class="mb-3 h9 ml-4 mr-3 text-left">
            Please describe in 2-3 sentences collaboration with the client? What went well and what didn’t?
            <br>
            <br>
            The comment will be published on the client's profile.
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea
            v-model="feedback"
            class="modal-feedback h9"
            placeholder="Your feedback helps other clients to evaluate their suitability with this client and avoid the stressful experience of working with an unsuitable partner."
            rows="6"
          />
        </b-col>
      </b-row>
      <b-row class="text-left ml-2 mt-4">
        <b-col>
          <b-form-checkbox
            v-model="hidden"
            class="d-inline"
            :value="true"
            :unchecked-value="false"
            required
          >
            <small class="h9 pb-1">
              Hide this feedback from client
            </small>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="text-left ml-2">
        <b-col>
          <b-form-checkbox
            v-model="anonymous"
            class="d-inline"
            :value="true"
            :unchecked-value="false"
            required
          >
            <small class="h9">
              Make feedback anonymous
            </small>
          </b-form-checkbox>
          <span
            v-b-tooltip.hover
            class="position-absolute ml-1"
            title="Your feedback is posted anonymously"
          >
            <i class="ri-question-line" />
          </span>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import axios from '@/helpers/cleanAxios'

export default {
  name: 'RecruiterFeedback',
  data () {
    return {
      match: {},
      score: null,
      feedback: '',
      anonymous: false,
      hidden: false,
      emojis: [
        { text: '😓', value: 1 },
        { text: '🙁', value: 2 },
        { text: '🙄', value: 3 },
        { text: '🙂', value: 4 },
        { text: '😍', value: 5 },
      ],
    }
  },
  created () {
    if ((new URLSearchParams(window.location.search)).get('feedback-recruiter')) {
      axios.get(`/v2/matches/${(new URLSearchParams(window.location.search)).get('feedback-recruiter')}`)
        .then(({ data }) => {
          this.match = data
        })
    }
  },
  methods: {
    submit () {
      axios.post('/v2/feedbacks', {
        for: 'business',
        score: this.score,
        feedback: this.feedback,
        anonymous: this.anonymous,
        hidden: this.hidden,
        businessId: this.match.project.business.id,
        matchId: this.match.id,
      })
        .then(() => {
          this.$bvModal.hide('RecruiterFeedback')
        })
        .then(() => {
          this.$bvModal.msgBoxOk('We really value your feedback as it helps us improve Relancer experience in the future for you and others. Together we can create the best recruitment community in the world. 💪🏼', {
            title: 'Thank you!',
            size: 'md',
            buttonSize: 'lg',
            headerClass: 'p-2 justify-content-center',
            centered: true,

          })
            .then(() => {
              this.$router.push('/')
            })
        })
        .catch((error) => {
          this.$bvToast.toast('Please answer all required fields', {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 3000,
            solid: true,
          })
          throw error
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn.btn-emoji.active {
  padding: 10px;
}
</style>
